module.exports = __webpack_public_path__ + "static/media/landing-banner-d.59c4e4bd.svg";